import { Post } from 'lib/types';
import { Masonry } from 'components/Masonry';
import { PostListSkeleton } from 'components/PostListSkeleton';
import { Alert, AlertTitle } from '@mui/material';
import { SinglePostResult } from 'features/Profile/SinglePostResult';

interface Props {
  posts: Post[];
  isLoading: boolean;
  error?: Error;
  onIgnoreSuggestedCredit?: (postId: number) => void;
}

export const FilterPostResult = ({
  posts,
  isLoading,
  error,
  onIgnoreSuggestedCredit,
}: Props) => {
  if (isLoading && !posts?.length) {
    return (<div className="mt-4"><PostListSkeleton /></div>);
  }

  if (error) {
    return (
      <Alert severity="error">
        <AlertTitle>Error</AlertTitle>
        {error.message || 'Something went wrong fetching data. Please double check your filters!'}
      </Alert>
    );
  }

  if (!isLoading && (!posts || posts.length <= 0)) {
    return (<div className="text-xl font-semibold text-center">No posts found for the selected filters</div>);
  }

  return (
    <Masonry>
      {posts.map((post) => (
        <SinglePostResult
          key={post.id}
          post={post}
          onIgnoreSuggestedCredit={onIgnoreSuggestedCredit}
          showFavorite={!post.matchId}
        />
      ))}
    </Masonry>
  );
};
